export default __webpack_public_path__ + "static/media/oscer-character-chat-help.cd891150.svg";